import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Login from "./components/Login";
import Logout from "./components/Logout";
import Home from "./components/Home";
import Portfolio from "./components/Portfolio";
import CryptoCoins from "./components/CryptoCoins";
import UserProfile from "./components/UserProfile";
import Payments from "./components/Payments";
import ContactUs from "./components/ContactUs";
import PaymentSuccess from "./components/PaymentSuccess";
import PaymentFailed from "./components/PaymentFailed";
import "./App.css";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("username"));

  return (
    <Router>
      <div className="app-container">
        {isLoggedIn && <Sidebar />}
        <div className="main-content">
          {isLoggedIn && <Logout setIsLoggedIn={setIsLoggedIn} />}
          <Routes>
            {!isLoggedIn ? (
              <Route path="/" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
            ) : (
              <>
                <Route path="/home" element={<Home />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/crypto" element={<CryptoCoins />} />
                <Route path="/profile" element={<UserProfile />} />
                <Route path="/payment" element={<Payments />} />
                <Route path="/contactus" element={<ContactUs />} />
                <Route path="/paymentsuccess" element={<PaymentSuccess />} />
                <Route path="/paymentfailed" element={<PaymentFailed />} />
                <Route path="*" element={<Navigate to="/home" />} />
              </>
            )}
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
